import Surface from "@able/react/dist/Surface";
import Icon from "@able/react/dist/Icon";
import Spacing from "@able/react/dist/Spacing";
import Divider from "@able/react/dist/Divider";
import TextStyle from "@able/react/dist/TextStyle";
import "./style.scss";
import ProgressNotstartedIcon from "../assets/images/progressTrackerNotstarted.svg";
import ProgressdottedDefault from "../assets/images/progressTrackerdottedDefault.svg";
import ProgressdottedProgress from "../assets/images/progressTrackerdottedProgress.svg";
import { IconTypes } from "@able/react/dist/Icon/generatedIconTypes";
import { ableTextAlias } from "../util/able-migration";

export const NOTSTARTED = "notStarted";
export const INPROGRESS = "InProgress";
export const WARNING = "Warning";
export const ERROR = "Error";
export const SUCCESS = "Success";

export interface trackerValuetype {
    title: string, description: string, content: string | JSX.Element, status: "notStarted" | "InProgress" | "Warning" | "Error" | "Success",
}

export interface ProgressTrackerProps {
    developmentUrl: string;
    titleOrder?: 2 | 3 | 4 | 5 | 6,
    trackerValues: trackerValuetype[];
}

const ProgressTracker = (props: ProgressTrackerProps) => {
    const { developmentUrl, trackerValues, titleOrder=2 } = props;
    return (
        <div className={`ted-ui-progressTracker`}>
            <ul className="content-list">
                {
                    trackerValues && trackerValues.map((trackerValue: trackerValuetype, i: number) => {
                        const screenReaderText = trackerValue.status.replace(/([A-Z])/g, " $1");
                        return (<li data-testid={trackerValue.status} key={`${trackerValue.status}_${i}`} className={`progressLevel ${trackerValues.length === (i + 1) ? "finalStep" : ""}`}>
                            <div className="left-column">
                                <div className="icon-section">
                                    {trackerValue.status === NOTSTARTED ?
                                        <ProgressNotstartedIcon className="not-started" role="img" focusable="false"/> : <Icon developmentUrl={developmentUrl} size='32' icon={trackerValue.status as IconTypes} screenReaderContent={screenReaderText.trim()} />}

                                    {(trackerValue.status === NOTSTARTED || trackerValue.status === INPROGRESS) ?
                                        <div className={`dot-container dot ${trackerValue.status}`}>
                                            {trackerValue.status === NOTSTARTED && <ProgressdottedDefault />}
                                            {trackerValue.status === INPROGRESS && <ProgressdottedProgress />}
                                        </div>
                                        : <div className={`line ${trackerValue.status}`}></div>}
                                </div>
                            </div>
                            <div className="right-column">
                                <div className="textGroup">
                                    <TextStyle alias="HeadingD" colour="Default" element={`h${titleOrder}`} alignment="Left" className="header-text">
                                        {trackerValue.title}
                                    </TextStyle>
                                    <TextStyle alias={ableTextAlias("FinePrint")} colour="Default" element="p" alignment="Left" className="sub_text">
                                        {trackerValue.description}
                                    </TextStyle>
                                </div>
                                {trackerValue.content && ((trackerValue.status === INPROGRESS) ?
                                    <Spacing top='spacing3x' bottom='spacing3x'>
                                        <Surface
                                            background="materialBaseTertiary"
                                            cornerRadius="cornerRadiusSlight"
                                            variant="SurfaceFlat"
                                        >
                                            <div className="progressContent progressBg">{trackerValue.content} </div>
                                        </Surface>
                                    </Spacing>
                                    : <div className="progressContent">{trackerValue.content}</div>)}
                                {trackerValue.content && <Spacing bottom="spacing2x">
                                    <Divider className="progress-divider" colour="dividerEmphasis" />
                                </Spacing>}
                            </div>
                        </li>
                        )
                    })
                }
            </ul>
        </div >
    );
};

export default ProgressTracker;
